/** One-time password reset code shaped `XXXX-XXXX` (hex). */
export class ResetCode {
    value;
    constructor(value) {
        this.value = value;
    }
    static normalize(raw) {
        const compact = raw.trim().replace(/[^a-f0-9]/gi, "").toUpperCase().slice(0, 8);
        return compact.length <= 4 ? compact : `${compact.slice(0, 4)}-${compact.slice(4)}`;
    }
    static parse(raw) {
        const normalized = ResetCode.normalize(raw);
        return /^[A-F0-9]{4}-[A-F0-9]{4}$/.test(normalized) ? new ResetCode(normalized) : null;
    }
    toString() {
        return this.value;
    }
}
//# sourceMappingURL=ResetCode.js.map